// assert (dev mode) - checks value and if value=false then log the message + shows alert for QA; returns value back!
// assert (release mode) - checks value and if value=false then log the message; returns value back!
// verify - checks value and if value=false then log the message; returns value back!
import nodeAssert from 'assert';
import * as localPreferences from 'utils/localPreferences';
import tracker from 'utils/tracker';

const { sprintf } = require('sprintf-js');

const getDescription = (message, ...substitutions) => {
  let description;

  if (typeof message === 'string') {
    description = sprintf(message, ...substitutions);
  } else if (String(message) !== '[object Object]') {
    description = String(message);
  } else {
    description = JSON.stringify(message, null, 2);
  }

  return description;
}

export const verify = (assertion, message, ...substitutions) => {
  if (!assertion) {
    const description = getDescription(message, ...substitutions);
    tracker.track(tracker.events.assert, { description });
    console.assert(assertion, message, ...substitutions); // eslint-disable-line no-console
  }
  return assertion;
};

export const assert = (assertion, message, ...substitutions) => {
  const result = verify(assertion, message, ...substitutions);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//////////////////////////////////////
////////////////
////////////////////////////////////////////////////////////////////////////
////////////////////////////////
////////////////////////////////////////////////////////////////////
//////////////////////////
/////////////////////
/////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
///////////////////////////////////////
//////////
////////////////////////////////////////////////////
////////////////////////////////////////
///////
/////
///
///////////

  return result;
};

export const setupAssert = () => { window.assert = assert };
export const setupVerify = () => { window.verify = verify };
